module.exports = __webpack_public_path__ + "static/img/star.b60c3c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/star.png
// module id = F344
// module chunks = 1